(function () {
  if (!document.body.classList.contains('template-index')) return;

  function unveilIndexLcp() {
    if (!window.lazySizes || !window.lazySizes.loader) return;
    var root = document.getElementById('MainContent');
    if (!root) return;
    root.querySelectorAll('.lazypreload').forEach(function (el) {
      window.lazySizes.loader.unveil(el);
    });
    var desktopHero = root.querySelector('.hero__image--desktop .lazyload');
    if (desktopHero) {
      window.lazySizes.loader.unveil(desktopHero);
    }
  }

  function initDeferredCart() {
    document.dispatchEvent(
      new CustomEvent('theme:cart:init', {
        bubbles: true,
        detail: { deferred: true }
      })
    );
  }

  function boot() {
    unveilIndexLcp();
    if (typeof window.tswSchedule === 'function') {
      window.tswSchedule(initDeferredCart, 'below');
    } else {
      window.setTimeout(initDeferredCart, 2600);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

